import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Service } from '../../app/service';

@Component({
  selector: 'page-about',
  templateUrl: 'about.html'
  //providers: [Service]
})

export class About {

  constructor(public navCtrl: NavController, private navParams: NavParams, private DataProvider: Service) {
    console.log("about");
  }

}



// WEBPACK FOOTER //
// ./src/pages/about/about.ts